
import _ from 'lodash';
import { useEffect, useState } from 'react';
import Table from '../../../../../common/components/table';


export const MarketPlacePolicyCategoryComponent = ({
    id,
    selectedPolicyCollections,
    setSelectedPolicyCollections,
    categories,
    closeModal,
    setSelectedCategories
}: any) => {
    console.log('categories', categories)
    const [currentCategories, setCurrentCategories] = useState<any>([]);

    const [
        columnDefs,
        setColumnDefs
    ] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
              field: 'Sl',
              sortable: false,
              filter: false,
              isSortLabel: true,
              headerName: 'Sl',
              cellRenderer(params: any) {
                return parseInt(
                  params.node.id,
                  10
                ) + 1;
              },
            },
            { field: 'CategoryName', headerName: 'Category Name', isEdit: true },
            // { field: 'ParentCategoryId', headerName: 'Parent Category', valueFormatter: getCategoryName },
            { field: 'IsPublished', headerName: 'Published', cellRenderer: 'yesNoRenderer' },
            { field: 'DisplayOrder', headerName: 'Display Order' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
        ]);
    }

    useEffect(() => {
        createColumnDefs();
    }, []);

    const handleSelect = (item: any, checked: any) => {
        console.log("Item:", item, "Checked:", checked);
        console.log('Selected Policy Collections:', selectedPolicyCollections?.Collections);

        const selectedItems = _.find(selectedPolicyCollections?.Collections?.EntityIds, (id: number) => {
            console.log(id, item.Id);
            return id === item.Id;
        });

        console.log('Selected Items:', selectedItems);

        if (checked && !selectedItems) {
            // Add item to the collection
            setCurrentCategories([...currentCategories, item]);
            console.log('Added item:', item);
        } else if (!checked && selectedItems) {
            console.log('Removed item:', item);
            // Remove item from the collection
            const newItems = _.map(selectedPolicyCollections?.Collections?.EntityIds, (id: number) => id !== item.Id);
            console.log('Selected items after removal:', newItems);
            setCurrentCategories(newItems);
        } else {
            console.log('Already present. doing nothing.')
        }
    }

    const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
    }

    const handleSelectCategories = () => {
        console.log('Selected Categories', currentCategories)
        // selectedPolicyCollections.Collections.EntityIds = currentCategories
        const entityIds = [];
        const mapToEntity = _.map(currentCategories, (category: any)=>{ 
            entityIds.push(category.Id);  
            return ({     
                "EntityTypeId": 4,
                "EntityTypeName": "Category",
                "EntityId": category.Id,
                "EntityName": category.Name,
                "MediaMappings": category.MediaMappings
            })
        })
        setSelectedPolicyCollections({
            ...selectedPolicyCollections,
            Collections: {
              ...selectedPolicyCollections.Collections,
              EntityIds: entityIds
            }
          });
        setSelectedCategories(mapToEntity)
        closeModal();
      }
  
    // useEffect(() => {
    //     _.map(categories, (item: any) => {
    //         _.map(selectedPolicyCollections.Collections.EntityIds, (id: number) => {
    //             if (item.Id === id) {
    //                 item["isChecked"] = true;
    //             }
    //         })
    //     })
    // }, [categories, selectedPolicyCollections.Collections.EntityIds]);


    return (
        <>
            <Table
                columnData={columnDefs}
                rowData={categories}
                onSelect={handleSelect} onSelectAll={handleSelectAll}
                headingName="Categories"
            />            

            <div className='flex w-full justify-end items-end'>
                <button
                onClick={closeModal}
                type='button'
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                Close
                </button>
                <button
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                onClick={handleSelectCategories}

                type="submit"
                >
                Save
                </button>
            </div>             
        </>
    )
}

export default MarketPlacePolicyCategoryComponent;
